import React from "react";
import Link from "next/link";
import styles from "./vlog_section_heading.module.scss";
import { useRouter } from "next/router";

export const VlogSectionHeading = ({
  title,
  subTitle,
  description,
  links,
  ...props
}) => {
  const router = useRouter();
  const { asPath } = router;

  return (
    <section className={styles.blog_hero_simple} {...props}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.breadcrumbs}>
            {links &&
              links.map((item, i) => (
                <Link legacyBehavior href={item.link} key={i}>
                  <a className={asPath === item.link ? styles.active : ""}>
                    {item.title}{" "}
                  </a>
                </Link>
              ))}
            <span className={styles.cat_title}>{subTitle}</span>
          </div>
          <h2 className={styles.title}>{title}</h2>
          {description && <p className={styles.short_desc}>{description}</p>}
        </div>
      </div>
    </section>
  );
};

export default VlogSectionHeading;
